import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DtcListValue } from '../../../../../shared/models/dtc/dtc-list-value';
import { RouterModule } from '@angular/router';
import { OpenPageComponent } from '../../../icons/open-page/open-page.component';

@Component({
  selector: 'app-dtc-value-list',
  imports: [CommonModule, RouterModule, OpenPageComponent],
  templateUrl: './dtc-value-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dtc-value-list.component.scss',
})
export class DtcValueListComponent {
  @Input() public dtcValues?: DtcListValue[];
}
